import { Home, User, Mail, BookOpen, GraduationCap, Bot } from "lucide-react";

export const NAV_LINKS = [
  { label: "Home", href: "/", icon: Home },
  { label: "About", href: "/about", icon: User },
  { label: "Timetable", href: "/timetable", icon: BookOpen },
  { label: "Contact", href: "/contact", icon: Mail },
  { label: "LMS", href: "https://www.lms.khalifaniyas.lk/", icon: GraduationCap },
  { label: "TeamICT AI", href: "https://chatgpt.com/g/g-697a80ddc2ec8191a729aa8e8a5ca26a-teamict-khalifa-niyas", icon: Bot },
];
